import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { ProductDao } from '@app/dao/product/product.dao';
import { SubscriptionFacadeService } from '../../services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
    selector: 'pee-perco-fees-form',
    templateUrl: './pee-perco-fees-form.component.html',
    styleUrls: ['./pee-perco-fees-form.component.scss'],
    standalone: false
})
export class PeePercoFeesFormComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    private productDao: ProductDao,
  ) {
    super(formConstructor);
  }

  displayInitialFees: boolean = true;
  minInitialFees: number = 0;
  maxInitialFees: number = 100;

  ngOnInit(): void {
    this.subscriptionFacade.initForm(this);
    const pledge = this.subscriptionFacade.getPledge();
    this.initProductFeesValues(pledge);
  }

  initProductFeesValues(pledge: any) {
    if (this.displayInitialFees) {
      this.productDao
        .getProduct(pledge?.products?.[0]?.productId as any)
        .subscribe(product => {
          this.minInitialFees =
            this.displayInitialFees &&
            this.floorValue(product.lifeInsuranceMinInitialPaymentFee * 100);
          this.maxInitialFees =
            this.displayInitialFees &&
            this.floorValue(product.lifeInsuranceMaxInitialPaymentFee * 100);

          if (this.displayInitialFees) {
            if (
              !this.maxInitialFees ||
              this.maxInitialFees < this.minInitialFees
            )
              this.maxInitialFees = this.minInitialFees;

            if (
              this.products
                .get(`${0}`)
                .get('parameters')
                .get('initialPaymentFeesPercent').value *
                100 <
              this.minInitialFees
            )
              this.products
                .get(`${0}`)
                .get('parameters')
                .get('initialPaymentFeesPercent')
                .setValue(this.minInitialFees);
          }
        });
    }
  }

  floorValue(value: number) {
    return Math.floor(value * 100) / 100;
  }

  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
